import { createFileRoute } from "@tanstack/react-router";

import { integerParam } from "../../../lib/url-state";
import { EpisodePage } from "../../../workspaces/production/pages/EpisodePage";

/** One recorded episode: a page of its own, which links back to its pod. `?t=` opens its
 *  recording at that moment, in milliseconds on the episode's own clock. */
export const Route = createFileRoute("/_console/production/episodes_/$episodeId")({
  validateSearch: (search: Record<string, unknown>): { readonly t?: number } => ({
    t: integerParam(search.t, { min: 0 }),
  }),
  component: Episode,
});

function Episode() {
  const { episodeId } = Route.useParams();
  const { t } = Route.useSearch();
  return <EpisodePage episodeId={episodeId} startMs={t} />;
}
